import type { SxProps } from '@mui/material';

import { Card, Tab as MUITab, Tabs as MUITabs } from '@mui/material';
import { Link } from 'react-router-dom';

export type TabsProps<T> = {
  items: Array<{
    label: string;
    link?: boolean;
    value: T;
  }>;
  onChange?: (value: T) => void;
  sx?: SxProps;
  value: T;
};

export const Tabs = <T,>({ items, onChange, sx, value }: TabsProps<T>) => {
  return (
    <MUITabs
      component={Card}
      onChange={(_, newValue) => onChange?.(newValue)}
      sx={{ px: 2, ...sx }}
      value={value}
    >
      {items.map((item) => (
        <MUITab
          key={[item.label, item.value].join(':')}
          label={item.label}
          sx={{ px: 2 }}
          value={item.value}
          {...(item.link
            ? {
                LinkComponent: item.link ? Link : undefined,
                to: item.link ? item.value : undefined,
              }
            : {})}
        />
      ))}
    </MUITabs>
  );
};
